import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../../shared/shared.module';
import { MaterialDesignModule } from '../../../shared/material-design/material-design.module';
import { SizeComponent } from './grouped-by-size/size.component';
import { TemplateComponent } from './grouped-by-template/template.component';
import { ViewCardsComponent } from './view-cards/view-cards.component';
import { CopyConfigurationModule } from '../copy-configuration/copy-configuration.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MaterialDesignModule,
    CopyConfigurationModule
  ],
  declarations: [
    SizeComponent,
    TemplateComponent,
    ViewCardsComponent,
  ],
  exports: [
    ViewCardsComponent,
    TemplateComponent
  ]
})
export class ViewCardsModule { }



// WEBPACK FOOTER //
// /app/src/app/hq/cards/view-cards/view-cards.module.ts